// extracted by mini-css-extract-plugin
export default {"container":"PayCallback_container__8xavW","button":"PayCallback_button__FGZcC","buttonWord":"PayCallback_buttonWord__H4aIS"};